const txteng15 = [
  [
    "Птица залетела в комнату через окно",
    "The bird flew into the room through the window",
  ],
  ["Он спустился в гараж", "He went down into the garage"],
  ["Мы перебежали через улицу", "We ran across the street"],
  [
    "Кот зашел в комнату и запрыгнул на стул",
    "The cat walked into the room and jumped on the chair",
  ],
  ["Полезай в машину", "Get into the car"],
  ["Тебе нужно вернуться к работе", "You need to get back to work"],
  ["Мяч перелетел через дорогу", "The ball flew over the road"],
  ["Я иду вдоль забора", "I'm walking along the fence"],
  ["Она быстро сбежала по ступенькам", "She quickly ran down the stairs"],
  ["Мы сейчас идем по улице", "We are walking down the street"],
  ["Самолет летит над городом", "The plane is flying over the city"],
  [
    "Ты сел в машину и быстро уехал",
    "You got into the car and quickly drove away",
  ],
  ["Помоги ей выйти из машины", "Help her get out of the car"],
  ["Он выпрыгнул из окна и убежал", "He jumped out of the window and ran away"],
  ["Я завтра вернусь", "I'll go back tomorrow"],
  [
    "Идите через поле, а затем спускайтесь к реке",
    "Go across the field and then get down to the river",
  ],
  ["Он поднялся вверх по лестнице", "He went upstairs"],
  ["Я сейчас еду вдоль реки", "I'm driving along the river"],
  ["Она поднялась с земли", "She got up from the ground"],
  ["Собака запрыгнула в коробку", "The dog jumped into the box"],
  ["Они быстро прибежали назад", "They quickly ran back"],
  ["Я перелезу через забор", "I'll get over the fence"],
  ["Он вылез через окно", "He got out through the window"],
  ["Как нам добраться до метро?", "How can we get to the subway?"],
  ["выкинуть из головы", "Get off my mind"],
];

export default txteng15;
